/** 
0 連結名稱,1 連結網址,2 名稱(簡體),3 名稱(日文),4 名稱(英文),5 封面圖片,6 描述
Funwards 白金會員,http://event.funnow.tw/funwards,,,funwards 白金會員,
FunNow 聯名卡 (8% 消費回饋),https://www.o-bank.com/web/Event/IMC_1081231/index.html?SourceCode=FunNow-website&CampaignCode=SD-DC-2018102501&utm_source=FunNow&utm_medium=website&utm_content=debitcard&utm_term=FunNow_website_181025,,,FunNow Co-branded Card,
Fun 玩生活，有 KOKO 就 GO,https://www.kokobank.com/Bank/news/Detail23,,,,
FunNow 刷花旗，即享三大優惠,https://event.myfunnow.com/citi,,,,
2019 米其林官方預訂,https://event.funnow.tw/michelingalashow,,,,
郵政 VISA 金融卡獨享 Fun 生活,https://event.myfunnow.com/chunghwapost,,,2019 Taipei Michelin Restaurant,
Travel Fun with UOB Cards,https://event.myfunnow.com/uob,,,,
FunNow東京 - 正式上線！,https://event.myfunnow.com/tokyolaunch,,,,
樂天信用卡卡友獨享預訂優惠,https://event.myfunnow.com/rakutencard,,,,

{
  img: '/web/images/hero_banner_1.jpg',
  title: 'Barsurfing #一起跑吧！',
  link: '',
  description: '酒鬼們喝起來！8/3-8/31 全台 80 間酒吧特製調酒喝不完，快來一起跑吧！'
}
 */
// unused function
export const eventParse = function (sheetData, locale = 'zh-tw') {
  const events = []
  const NameIndex = {
    'zh-tw': 0,
    'zh-cn': 2,
    ja: 3,
    en: 4,
  }
  const lines = sheetData.split(/\r?\n/)
  lines.forEach((line, i) => {
    // 第一行說明內容,不處理
    if (i === 0) {
      return false
    }
    // 資料以,隔開
    // 連結名稱,網址,簡中,日文,英文,封面圖
    const data = line.split(',')
    if (data[0] === '' || data[1] === '') {
      return false
    }
    const nameIdx = NameIndex[locale]
    let name = data[nameIdx]
    name = name.trim()
    if (name === '') {
      name = data[0].trim()
    }
    events.push({
      img: data[5].trim(),
      title: name,
      link: data[1].trim(),
      description: data[6].trim(),
    })
  })

  return events
}

export function parsePureHintText(text = '') {
  try {
    return text.split(/\r\n|\r|\n/)?.filter(Boolean)
  } catch (error) {
    return []
  }
}
